import Vue from 'vue'
import Vuex from 'vuex'
import Stomp from "stompjs";
import { chapterList } from "@/api/chapter";
import { userInfo } from "@/api/user";
import { handleTree } from "@/utils";

import simulation from './modules/simulation'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    simulation
  },
  state: {
    isLogin: !!localStorage.getItem('Authorization') || !!sessionStorage.getItem('Authorization'),
    myInfo: JSON.parse(localStorage.getItem('myInfo')) || null,
    chapterList: [],
    update: false,
    test: {},
    stompClient: null
  },
  mutations: {
    SET_LOGIN(state, ctx) {
      state.isLogin = ctx;
    },
    SET_MYINFO(state, val) {
      state.myInfo = val;
      localStorage.setItem('myInfo', JSON.stringify(val));
    },
    CLEAR_MYINFO(state) {
      state.myInfo = null;
      localStorage.removeItem('myInfo');
    },
    SET_CHAPTERS(state, ctx) {
      state.chapterList = ctx;
    },
    SET_UPDATE(state, ctx) {
      state.update = ctx;
    },
    SET_TEST(state, ctx) {
      state.test = ctx;
    },
    SET_STOMPCLIENT(state, ctx) {
      state.stompClient = ctx;
    }
  },
  actions: {
    //   用户信息
    getUserInfo(content) {
      userInfo().then((res) => {
        if (res.code == 0) {
          content.commit("SET_MYINFO", res.data);
        } else {
          console.log(res.msg);
        }
      });
    },
    // 章节列表
    getChapterList(content, payload) {
      chapterList({
        classId: payload.classId
      }).then((res) => {
        if (res.code == 0) {
          //   console.log(res);
          let list = handleTree(res.data, "chapterId");
          content.commit("SET_CHAPTERS", list);
        } else {
          console.log(res.msg);
        }
      });
    },
    // 连接聊天室
    connectChat(content) {
      const socket = new WebSocket(`${process.env.VUE_APP_WS_DOMAIN}/app/ws`);
      const stompClient = Stomp.over(socket);
      content.commit("SET_STOMPCLIENT", stompClient);
      if (!stompClient.connected) {
        stompClient.connect({
          token: localStorage.getItem("Authorization") || sessionStorage.getItem('Authorization'),
        },
          (frame) => {
            console.log(frame);
            content.commit("SET_UPDATE", true);
          },
          (error) => {
            console.log(error);
          }
        );
      }
    },
    closeChat() {
      this.state.stompClient.ws.onclose();
    }
  }
})